import { TENANT_AT, TENANT_CH, TYPE_PDP_CENTER } from 'shared/consts'
import {
  EXPERIMENT_VARIATION,
  PDP_CSW_TITLE_CHANGE,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import { type Experiment } from 'types/shopConfig'

export const NEW_PDP_CSW_TITLE_EXPERIMENT_CSW_IDS: {
  [key: string]: number
} = {
  [TENANT_CH]: 350,
  [TENANT_AT]: 407,
}

export const getPdpCswTitleChangeExperimentProps = ({
  experiments,
  tenant,
  wid,
  widgets,
}: {
  experiments: Experiment[]
  tenant: string
  wid: string
  widgets: Record<string, string>
}): undefined | { wid: number } => {
  const pdpCswTitleExperiment = getExperiment(PDP_CSW_TITLE_CHANGE, experiments)
  if (
    (tenant === TENANT_CH || tenant === TENANT_AT) &&
    widgets[TYPE_PDP_CENTER] === wid &&
    pdpCswTitleExperiment.isEnabled
  ) {
    if (pdpCswTitleExperiment.variant === EXPERIMENT_VARIATION.V1) {
      const finalWid = NEW_PDP_CSW_TITLE_EXPERIMENT_CSW_IDS[tenant]
      return { wid: finalWid }
    }
  }
}

export default () => {
  const { isEnabled } = getExperimentOnClient(PDP_CSW_TITLE_CHANGE)

  if (isEnabled) {
    void activateExperiment(PDP_CSW_TITLE_CHANGE)
  }
}
